export const FILTER_DEFAULTS = {
    searchTerm: "",
    pastEvents: false,
    onlyShowCurrentUserAttendingEvents: false,
    startOfCurrentDay: new Date(), // should be tz adjusted?
    includeAttendeesNames: false,
    includeHostNames: false,
    onlyShowCurrentUserHostingEvents: false,
};
